const info = {
  CN: {
    intro: "公司简介",
    honor: "公司荣誉",
    knowledge: "知识产品",
    banner:
      "http://resource.jmjnsz.com/jmjn-portal/2023/08/12/66fdeeff-3c99-4f50-a6b3-9a68dbdfa00e.jpg",
    mapInfo: "地图信息",
    address_CN: "深圳市南山区高新南九道西北工业大学三航科技大厦2105",
  },
  EN: {
    intro: "Company Profile",
    honor: "Corporate Honors",
    knowledge: "Intellectual property",
    banner:
      "http://resource.jmjnsz.com/jmjn-portal/2023/08/12/cc71e91d-40d3-4978-b098-28f28a4e3df1.jpg",
    mapInfo: "Map Information",
    address_EN:
      "Room 2105, Sanhang Science & Technology Building, Northwestern Polytechnical University, Gaoxin South 9th Road, Nanshan District, Shenzhen, China",
  },
};
export default info;



// WEBPACK FOOTER //
// ./src/language/about/index.js